module.exports = __webpack_public_path__ + "static/img/recommend_product3_max.8960cfd6.png";